const notificationAnalyticsTypes = {
    GET_AUTO_NOTIFICATION_ANALYTICS_PENDING: "GET_AUTO_NOTIFICATION_ANALYTICS_PENDING",
    GET_AUTO_NOTIFICATION_ANALYTICS_SUCCESS: "GET_AUTO_NOTIFICATION_ANALYTICS_SUCCESS",
    GET_AUTO_NOTIFICATION_ANALYTICS_ERROR: "GET_AUTO_NOTIFICATION_ANALYTICS_ERROR",
}

export default notificationAnalyticsTypes;
